var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNrgLogoLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1080_183876)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.3999 24.5C19.0273 24.5 24.3999 19.1274 24.3999 12.5C24.3999 5.87258 19.0273 0.5 12.3999 0.5C5.77249 0.5 0.399902 5.87258 0.399902 12.5C0.399902 19.1274 5.77249 24.5 12.3999 24.5Z",
    fill: "#00AB58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4025 4.30005L17.3999 9.36449L12.4003 14.4259L10.4001 12.4013L13.4001 9.36449L12.4003 8.35199L8.39999 12.4013L12.4003 16.4507L18.4001 10.3765L20.3999 12.4013L12.4003 20.5L4.3999 12.4013L12.4025 4.30005Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3998 24.0999C18.8063 24.0999 23.9998 18.9064 23.9998 12.4999C23.9998 6.0934 18.8063 0.899902 12.3998 0.899902C5.9933 0.899902 0.799805 6.0934 0.799805 12.4999C0.799805 18.9064 5.9933 24.0999 12.3998 24.0999Z",
    stroke: "#00AB58"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1080_183876"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.399902 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNrgLogoLight);
export default __webpack_public_path__ + "static/media/NRGLogoLight.404b688c2eeb81e75b804745179f294a.svg";
export { ForwardRef as ReactComponent };